import { intervalToDuration } from "date-fns";

export const formatDuration = ( ms: number ) => {
  const {
    hours,
    minutes,
    seconds,
  } = intervalToDuration({ start: 0, end: ms });

  let formattedDuration = "";

  if( hours && hours > 0 ) formattedDuration = formattedDuration.concat(`0${ hours ?? 0 }:`.slice( -2 ))

  formattedDuration = formattedDuration.concat(`0${ minutes ?? 0 }:`.slice( -2 ))

  return formattedDuration.concat(`0${ seconds ?? 0 }`.slice( -2 ))
};
